


const MK_UPSELL = {
  busy: false,
  
  cooldownMs: 900,
};

function mkUpsellSyncButtons() {
  document.querySelectorAll('.mk-upsell__btn').forEach((button) => {
    if (MK_UPSELL.busy) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  });
}

class MkCartUpsell extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.mk-upsell__btn');
    if (!this.button) return;


    if (MK_UPSELL.busy) this.button.setAttribute('aria-busy', 'true');

    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      this.upgrade();
    });
  }

  cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    });
  }

  async getCart() {
    const response = await fetch(`${this.cartUrl()}.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    return response.json();
  }

  
  findPreviousLineKey(cart, previousVariantId) {
    const wanted = String(previousVariantId);
    const line = (cart.items || []).find((item) => {
      const sameVariant = String(item.variant_id) === wanted;
      const properties = item.properties || {};
      const technical = properties._mk_upsold || properties._encore_cadeau;
      return sameVariant && !technical;
    });
    return line ? line.key : null;
  }

  async upgrade() {
    if (MK_UPSELL.busy || window.MKCartSync.busy) return;

    const variantId = this.dataset.variantId;
    const previousVariantId = this.dataset.previousVariantId;
    if (!variantId || !previousVariantId) return;

    MK_UPSELL.busy = true;
    mkUpsellSyncButtons();

    try {

      await window.MKCartSync.run(async () => {
      const added = await this.postJson(routes.cart_add_url, {
        id: variantId,
        quantity: 1,
        properties: { _mk_upsold: '1' },
      });
      if (!added.ok) throw new Error(`add.js ${added.status}`);

      const cart = await this.getCart();
      const staleKey = this.findPreviousLineKey(cart, previousVariantId);


      if (staleKey) {
        const removed = await this.postJson(routes.cart_change_url, { id: staleKey, quantity: 0 });
        if (!removed.ok) throw new Error(`change.js ${removed.status}`);
      } else {
        console.warn('[mk-upsell] ancienne ligne introuvable, non supprimée');
      }

      });
      await this.refresh();
    } catch (error) {
      console.error('[mk-upsell]', error);
      await this.refresh();
    } finally {


      setTimeout(() => {
        MK_UPSELL.busy = false;
        mkUpsellSyncButtons();
      }, MK_UPSELL.cooldownMs);
    }
  }

  
  async refresh() {
    await window.MKCartSync.refresh();
  }

}

if (!customElements.get('mk-cart-upsell')) {
  customElements.define('mk-cart-upsell', MkCartUpsell);
}

